// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ky","subtitle":"Ly","contentWrap":"My","imgWrap":"Ny","heading":"Oy","copy":"Py"};